import updateReportData from "./update-report-data";
import updateLanguage from "./update-language";
import updateTheme from "./update-theme";
import updateModal from "./update-modal";
import updateLoadState from "./update-load-state";
import updateInfos from "./update-infos";
import updateRequestingState from "./update-requesting-state";
import updateEditState from "./update-editing-state";
import updateEditMode from "./update-edit-mode";

import { clear_store } from "../../actions/actionConstants";
import updateSettings from "./update-settings";

const reportReducer = (state, action) => {
    // Clear report store
    if (action.type === clear_store) {
        state = undefined;
    }

    const newState = {
        // All exam and report data
        reportData: {
            report: updateReportData(state, action),
            settings: updateSettings(state, action)
        },

        // App state
        app: {
            settings: {
                editMode: updateEditMode(state, action),
                lang: updateLanguage(state, action), // Language
                theme: updateTheme(state, action)
            },

            loadState: updateLoadState(state, action), // Main app and data loading state
            editState: updateEditState(state, action), // Editing data and state
            requestingState: updateRequestingState(state, action),
            modal: updateModal(state, action), // Modal popup dialogs
            infoMessages: updateInfos(state, action) // Information messages (panels)
        }
    };
    return newState;
};
export default reportReducer;
